import { TextSortBy } from "nystem-components";

const DateSortBy = (props) => <TextSortBy {...props} />;
export default DateSortBy;
